module.exports = __webpack_public_path__ + "static/media/Iphone.1295b226.png";